export const fetchIMask = async () => import('imask' /* webpackChunkName: "imask" */).then((m) => m.default);

export const fetchLightgallery = async () => import('lightgallery' /* webpackChunkName: "lightgallery" */);
